export const siteSettings = {
  name: "Prime Block Vault",
  link: "https://primeblockvault.com",
  email: "support@primeblockvault.com",
  appLink: "https://app.primeblockvault.com",
};
